<div class="connection-health-panel">
  <h4>Vendor connectivity</h4>

  @if (isExpired) {
  <!-- SRA003-430: terminal expired state — non-green, reconnect CTA. -->
  <div class="expired-banner" role="alert">
    <span class="status-chip status-verification-needed">
      {{ providerLabel }} telemetry connection expired
    </span>
    <p class="muted small">
      The connection to {{ providerLabel }} has expired, so no telemetry is
      flowing. Reconnect to resume.
    </p>
    <button
      class="btn-small btn-primary"
      type="button"
      (click)="reconnect()"
      [disabled]="isReconnecting"
    >
      {{ isReconnecting ? 'Reconnecting…' : 'Reconnect telemetry' }}
    </button>
  </div>
  } @else {
  <p class="muted small">
    Run a quick health check to confirm Harvest Mate can still talk to
    {{ providerLabel }} on your behalf.
  </p>

  <button
    class="btn-small btn-primary"
    type="button"
    (click)="testConnection()"
    [disabled]="isChecking"
  >
    {{ isChecking ? 'Testing…' : 'Test connection' }}
  </button>

  @if (showLiveDataCta) {
  <button
    class="btn-small btn-left-space"
    type="button"
    (click)="enableLiveData()"
    [disabled]="isEnabling || !canEnableLiveData"
    [title]="canEnableLiveData ? '' : liveDataTooltip"
  >
    {{ isEnabling ? 'Enabling…' : 'Enable live data' }}
  </button>
  }

  @if (lastResult) {
  <div
    class="health-result margin-top-small"
    [class.health-ok]="lastResult.ok"
    [class.health-error]="!lastResult.ok"
  >
    @if (lastResult.ok) {
    <span class="status-chip status-connected">OK &mdash; {{ providerLabel }}</span>
    } @else {
    <span class="status-chip status-verification-needed">
      Failed{{ lastResult.error ? ' — ' + lastResult.error : '' }}
    </span>
    }
    <div class="muted small">Last checked: {{ lastResult.lastChecked }}</div>
  </div>
  }
  }
</div>
